export const environment = {
    production: false,
    midOfficeApiUrl: "https://api-midoffice.maxula-travel.solutionsplus.ovh/api/v1",
    cronApiUrl: "https://api-midoffice.maxula-travel.solutionsplus.ovh",
    editoFrontUrl: "https://front-edito.maxula-travel.solutionsplus.ovh",
    editoApiUrl: "https://api-edito.maxula-travel.solutionsplus.ovh/api",
    server: "PREPROD",
};
